// extracted by mini-css-extract-plugin
export default {"container":"PageContainer_container__LgF+X","removePaddings":"PageContainer_removePaddings__Lav2M","containerInner":"PageContainer_containerInner__RgsPT"};